import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [mobileAboutOpen, setMobileAboutOpen] = useState(false);
  const [mobileExhibitionOpen, setMobileExhibitionOpen] = useState(false);
  const [mobileSponsorsOpen, setMobileSponsorsOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => {
    setMobileMenuOpen(false);
    setMobileAboutOpen(false);
    setMobileExhibitionOpen(false);
    setMobileSponsorsOpen(false);
  };

  const isAboutActive =
    location.pathname === "/about" ||
    location.pathname === "/gris-2025";

  const isExhibitionActive =
    location.pathname === "/exhibition" ||
    location.pathname === "/floor-plan";

  const isSponsorsActive =
    location.pathname === "/sponsors" ||
    location.pathname === "/sponsorship" ||
    location.pathname === "/sponsorship-benefits";

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 bg-white shadow-md">
        
        {/* Top Mini Utility Bar for External Link */}
        <div className="bg-[#0a1d37] text-white text-[11px] py-1 px-4 lg:px-8 hidden lg:flex justify-end items-center gap-6">
          <a
            href="https://www.indiairf.com"
            target="_blank"
            rel="noopener noreferrer"
            className="hover:text-orange-400 font-medium flex items-center gap-1 transition-colors"
          >
            <span>Visit Official IRF India Website</span>
            <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>
        </div>

        {/* Main Header Bar */}
        <div className="max-w-7xl mx-auto px-4 lg:px-8 py-2 lg:py-3 flex items-center justify-between">
          
          {/* Logo & Title Group */}
          <Link
            to="/"
            onClick={closeMenu}
            className="flex items-center gap-3 lg:gap-5 group outline-none"
          >
            <div className="flex items-center gap-2">
              <img
                src="/irf-india.png"
                alt="IRF India"
                className="h-14 md:h-16 lg:h-20 object-contain transition-transform duration-300 group-hover:scale-105"
              />
              <img
                src="/gris-2026.png"
                alt="GRIS 2027"
                className="h-14 md:h-16 lg:h-20 object-contain transition-transform duration-300 group-hover:scale-105"
              />
            </div>

            <div className="hidden sm:flex flex-col text-[#0a1d37] whitespace-nowrap border-l border-slate-200 pl-4 lg:pl-5">
              <h1 className="text-[11px] md:text-sm lg:text-base font-black tracking-tight leading-none mb-1">
                Global Road Infratech
                <br />
                Summit & Expo 2027
              </h1>
              <p className="text-[9px] lg:text-[11px] font-extrabold tracking-widest leading-tight">
                14 - 15 JANUARY 2027
              </p>
              <p className="text-[9px] lg:text-[11px] font-bold leading-tight text-slate-700">
                Dr.Ambedkar International Centre
              </p>
              <p className="text-[9px] lg:text-[11px] font-bold leading-tight text-slate-700">
                New Delhi - 110001 <span className="text-red-600 px-0.5 text-xs font-black">|</span> India
              </p>
            </div>
          </Link>

          {/* DESKTOP NAV */}
          <nav className="hidden xl:flex items-center gap-5">
            <Link
              to="/"
              className={`text-[13px] font-bold tracking-wide uppercase ${
                location.pathname === "/" ? "text-orange-700" : "text-[#0a1d37] hover:text-orange-700"
              }`}
            >
              Home
            </Link>

            {/* ABOUT DROPDOWN */}
            <div className="relative group py-2">
              <button
                className={`text-[13px] font-bold tracking-wide uppercase flex items-center gap-1 transition-colors duration-300 ${
                  isAboutActive ? "text-orange-700" : "text-[#0a1d37] group-hover:text-orange-700"
                }`}
              >
                About <span className="text-[10px]">▼</span>
              </button>
              <div className="absolute top-full left-0 mt-0 w-48 bg-white shadow-xl rounded-b-lg border-t-2 border-orange-500 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 flex flex-col overflow-hidden">
                <Link
                  to="/about"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700 border-b border-slate-100"
                >
                  About GRIS 2027
                </Link>
                <a
                  href="https://indiairf.com/gris2026/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700 border-b border-slate-100"
                >
                  GRIS 2026 ↗
                </a>
                <Link
                  to="/gris-2025"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700"
                >
                  GRIS 2025
                </Link>
              </div>
            </div>

            <Link
              to="/schedule"
              className={`text-[13px] font-bold tracking-wide uppercase ${
                location.pathname === "/schedule" ? "text-orange-700" : "text-[#0a1d37] hover:text-orange-700"
              }`}
            >
              Program
            </Link>

            {/* EXHIBITION DROPDOWN */}
            <div className="relative group py-2">
              <button
                className={`text-[13px] font-bold tracking-wide uppercase flex items-center gap-1 transition-colors duration-300 ${
                  isExhibitionActive ? "text-orange-700" : "text-[#0a1d37] group-hover:text-orange-700"
                }`}
              >
                Exhibition <span className="text-[10px]">▼</span>
              </button>
              <div className="absolute top-full left-0 mt-0 w-56 bg-white shadow-xl rounded-b-lg border-t-2 border-orange-500 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 flex flex-col overflow-hidden">
                <Link
                  to="/floor-plan"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700 border-b border-slate-100"
                >
                  Floor Plan
                </Link>
                <Link
                  to="/exhibition"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700"
                >
                  Stall Booking & Packages
                </Link>
              </div>
            </div>

            {/* SPONSORS DROPDOWN */}
            <div className="relative group py-2">
              <button
                className={`text-[13px] font-bold tracking-wide uppercase flex items-center gap-1 transition-colors duration-300 ${
                  isSponsorsActive ? "text-orange-700" : "text-[#0a1d37] group-hover:text-orange-700"
                }`}
              >
                Sponsors <span className="text-[10px]">▼</span>
              </button>
              <div className="absolute top-full left-0 mt-0 w-60 bg-white shadow-xl rounded-b-lg border-t-2 border-orange-500 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 flex flex-col overflow-hidden">
                <Link
                  to="/sponsorship"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700 border-b border-slate-100"
                >
                  Become a Sponsor
                </Link>
                <Link
                  to="/sponsorship-benefits"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700 border-b border-slate-100"
                >
                  Sponsorship Opportunities
                </Link>
                <Link
                  to="/sponsors"
                  className="px-4 py-3 text-sm font-bold text-[#0a1d37] hover:bg-slate-50 hover:text-orange-700"
                >
                  Our Sponsors
                </Link>
              </div>
            </div>

            <Link
              to="/delegates"
              className={`text-[13px] font-bold tracking-wide uppercase ${
                location.pathname === "/delegates" ? "text-orange-700" : "text-[#0a1d37] hover:text-orange-700"
              }`}
            >
              Delegates
            </Link>

            <Link
              to="/contact"
              className={`text-[13px] font-bold tracking-wide uppercase ${
                location.pathname === "/contact" ? "text-orange-700" : "text-[#0a1d37] hover:text-orange-700"
              }`}
            >
              Contact
            </Link>
          </nav>

          {/* RIGHT SIDE BUTTONS */}
          <div className="flex items-center gap-3">
            <Link
              to="/brochure"
              className="hidden lg:inline-flex px-6 py-2.5 rounded-full text-xs font-black uppercase tracking-wider transition-all shadow-md hover:-translate-y-0.5 bg-orange-700 text-white hover:bg-orange-800"
            >
              Brochure
            </Link>

            <button
              className="xl:hidden relative z-50 p-2 text-[#0a1d37]"
              aria-label="Toggle Navigation Menu"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            >
              <div className="w-6 flex flex-col gap-1.5">
                <span
                  className={`block h-0.5 w-full bg-current rounded transition-transform duration-300 ${
                    mobileMenuOpen ? "rotate-45 translate-y-2 text-white" : ""
                  }`}
                ></span>
                <span
                  className={`block h-0.5 w-full bg-current rounded transition-opacity duration-300 ${
                    mobileMenuOpen ? "opacity-0" : ""
                  }`}
                ></span>
                <span
                  className={`block h-0.5 w-full bg-current rounded transition-transform duration-300 ${
                    mobileMenuOpen ? "-rotate-45 -translate-y-2 text-white" : ""
                  }`}
                ></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE MENU */}
      <div
        className={`fixed inset-0 z-40 bg-[#0a1d37]/95 backdrop-blur-xl transition-all duration-500 xl:hidden overflow-y-auto ${
          mobileMenuOpen ? "opacity-100 visible" : "opacity-0 invisible pointer-events-none"
        }`}
      >
        <nav className="flex flex-col items-center justify-center min-h-screen py-20 px-8 gap-5 text-center">
          
          {/* Mobile Website Link */}
          <a
            href="https://www.indiairf.com"
            target="_blank"
            rel="noopenner noreferrer"
            onClick={closeMenu}
            className="text-base font-bold text-orange-400 hover:text-white uppercase tracking-wider mb-2 flex items-center gap-2"
          >
            <span>Visit IRF India Website</span>
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
            </svg>
          </a>

          <Link
            to="/"
            onClick={closeMenu}
            className="text-2xl font-black uppercase tracking-widest text-white hover:text-orange-400"
          >
            Home
          </Link>

          {/* ABOUT ACCORDION */}
          <div className="flex flex-col items-center w-full">
            <button
              onClick={() => setMobileAboutOpen(!mobileAboutOpen)}
              className={`text-2xl font-black uppercase tracking-widest flex items-center justify-center gap-2 w-full ${
                isAboutActive ? "text-orange-500" : "text-white"
              }`}
            >
              About
              <span className={`text-sm transition-transform duration-300 ${mobileAboutOpen ? "rotate-180" : ""}`}>
                ▼
              </span>
            </button>
            <div
              className={`flex flex-col gap-4 overflow-hidden transition-all duration-300 w-full bg-white/5 rounded-2xl mt-2 ${
                mobileAboutOpen ? "max-h-60 py-4 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <Link to="/about" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                About GRIS 2027
              </Link>
              <a
                href="https://indiairf.com/gris2026/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={closeMenu}
                className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider"
              >
                GRIS 2026 ↗
              </a>
              <Link to="/gris-2025" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                GRIS 2025
              </Link>
            </div>
          </div>

          <Link
            to="/schedule"
            onClick={closeMenu}
            className="text-2xl font-black uppercase tracking-widest text-white hover:text-orange-400"
          >
            Program
          </Link>

          {/* EXHIBITION ACCORDION */}
          <div className="flex flex-col items-center w-full">
            <button
              onClick={() => setMobileExhibitionOpen(!mobileExhibitionOpen)}
              className={`text-2xl font-black uppercase tracking-widest flex items-center justify-center gap-2 w-full ${
                isExhibitionActive ? "text-orange-500" : "text-white"
              }`}
            >
              Exhibition
              <span className={`text-sm transition-transform duration-300 ${mobileExhibitionOpen ? "rotate-180" : ""}`}>
                ▼
              </span>
            </button>
            <div
              className={`flex flex-col gap-4 overflow-hidden transition-all duration-300 w-full bg-white/5 rounded-2xl mt-2 ${
                mobileExhibitionOpen ? "max-h-60 py-4 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <Link to="/floor-plan" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                Floor Plan
              </Link>
              <Link to="/exhibition" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                Stall Booking & Packages
              </Link>
            </div>
          </div>

          {/* SPONSORS ACCORDION */}
          <div className="flex flex-col items-center w-full">
            <button
              onClick={() => setMobileSponsorsOpen(!mobileSponsorsOpen)}
              className={`text-2xl font-black uppercase tracking-widest flex items-center justify-center gap-2 w-full ${
                isSponsorsActive ? "text-orange-500" : "text-white"
              }`}
            >
              Sponsors
              <span className={`text-sm transition-transform duration-300 ${mobileSponsorsOpen ? "rotate-180" : ""}`}>
                ▼
              </span>
            </button>
            <div
              className={`flex flex-col gap-4 overflow-hidden transition-all duration-300 w-full bg-white/5 rounded-2xl mt-2 ${
                mobileSponsorsOpen ? "max-h-60 py-4 opacity-100" : "max-h-0 opacity-0"
              }`}
            >
              <Link to="/sponsorship" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                Become a Sponsor
              </Link>
              <Link to="/sponsorship-benefits" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                Sponsorship Opportunities
              </Link>
              <Link to="/sponsors" onClick={closeMenu} className="text-lg font-bold text-slate-200 hover:text-white uppercase tracking-wider">
                Our Sponsors
              </Link>
            </div>
          </div>

          <Link
            to="/delegates"
            onClick={closeMenu}
            className="text-2xl font-black uppercase tracking-widest text-white hover:text-orange-400"
          >
            Delegates
          </Link>

          <Link
            to="/contact"
            onClick={closeMenu}
            className="text-2xl font-black uppercase tracking-widest text-white hover:text-orange-400"
          >
            Contact
          </Link>

          <Link
            to="/brochure"
            onClick={closeMenu}
            className="mt-6 px-8 py-4 rounded-xl text-sm font-black uppercase tracking-wider bg-orange-700 text-white shadow-lg mx-auto w-full max-w-xs"
          >
            Brochure
          </Link>
        </nav>
      </div>
    </>
  );
}